module.exports = {
	"notification.message": "Wix.com använder cookies för att ge dig bästa möjliga upplevelse.",
	"notification.got.it": "Jag förstår",
	"notification.more.info": "Läs mer",
	"notification.got.it.arrow": "arrow icon"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_sv.json
// module id = 51
// module chunks = 0